<template>
  <v-list-tile @click="open">
    <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'plus']"></font-awesome-icon></v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-title>住所を追加する</v-list-tile-title>
    </v-list-tile-content>
    <v-list-tile-action class="text-xs-right">
      <v-btn flat :disabled="true"></v-btn>
    </v-list-tile-action>
    <v-dialog scrollable v-model="config.status.active" max-width="600">
      <v-card>
        <v-card-title class="grey lighten-3 blue-grey--text text--darken-4">
          <span class="headline">住所の追加</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md class="pa-0">
            <v-form ref="form" v-model="form.valid" lazy-validation>
              <v-layout wrap>
                <v-flex xs12>
                  <v-select ref="relatedAddress"
                    v-model="config.address.src"
                    :items="getSrcAddressItems"
                    item-text="text"
                    item-value="value"
                    label="関連のある住所を使用する"
                    :disabled="isLoading"
                    @change="cpAddress"></v-select>
                </v-flex>
                <v-flex xs10>
                  <v-text-field required
                    v-model="form.zip"
                    label="郵便番号"
                    mask="###-####"
                    :rules="rules.zip"
                    @keypress.enter="search"></v-text-field>
                </v-flex>
                <v-flex xs2>
                  <v-btn icon flat
                    color="blue darken-2"
                    :loading="isSearching"
                    @click.stop="search"
                  ><font-awesome-icon :icon="['fas', 'search']" /></v-btn>
                </v-flex>
                <v-flex xs12 class="">
                  <v-select required
                    v-model="form.pref"
                    label="都道府県"
                    :items="getPrefItems"
                    :rules="rules.pref"></v-select>
                </v-flex>
                <v-flex xs12 class="">
                  <v-text-field required
                    v-model="form.city"
                    label="市町村区"
                    :rules="rules.city"></v-text-field>
                </v-flex>
                <v-flex xs12 class="">
                  <v-text-field ref="number" required
                    v-model="form.number"
                    label="番地・建物"
                    :rules="rules.number"></v-text-field>
                </v-flex>
                <v-flex xs12 class="">
                  <v-text-field required
                    v-model="form.kana"
                    label="ふりがな"
                    :rules="rules.kana"></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="grey lighten-3">
          <v-btn flat
            color="blue darken-2"
            @click="close">閉じる</v-btn>
          <v-spacer></v-spacer>
          <v-btn depressed color="blue darken-2" class="white--text"
            :disabled="!isValid"
            :loading="isLoading"
            @click="submit">追加する</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-list-tile>
</template>

<script>
export default {
  name: 'insert-modal',
  props: [
    'gid'
  ],
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false,
          searching: false
        },
        address: {
          src: ''
        }
      },
      store: {
        addresses: []
      },
      rules: {
        zip: [
          v => !!v || '必須項目です'
        ],
        pref: [
          v => !!v || '必須項目です'
        ],
        city: [
          v => !!v || '必須項目です'
        ],
        number: [
          v => !!v || '必須項目です'
        ],
        kana: [
          v => !!v || '必須項目です',
          v => !/[^ぁ-ん]/.test(v) || '平仮名のみ入力有効です'
        ]
      },
      form: {
        valid: true,
        zip: '',
        pref: '',
        city: '',
        number: '',
        kana: ''
      }
    }
  },
  methods: {
    init: function () {
      this.$set(this, 'form', {
        valid: true,
        zip: '',
        pref: '',
        city: '',
        number: '',
        kana: ''
      })
      this.searchSrc()
    },
    open: function () {
      this.init()
      this.$set(this.config.status, 'active', true)
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    submit: function () {
      if (this.$refs.form.validate()) {
        if (this.$props.gid) {
          this.$set(this.config.status, 'loading', true)
          this.axios.post(this.$url.api + 'user/about/insert/address', {
            cid: this.$props.gid,
            zip: this.form.zip,
            pref: this.form.pref,
            city: this.form.city,
            number: this.form.number,
            kana: this.form.kana
          }, {
            headers: {
              'user-token': this.$localStorage.get('jwt')
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$emit('emit', {
                action: 'insertAddress',
                data: {
                  id: this.$props.gid,
                  address: res.data.data
                }
              })
            }
            this.$set(this.config.status, 'loading', false)
            this.$set(this.config.status, 'active', false)
          })
        }
      }
    },
    search: function () {
      if (this.form.zip.length === 7 && !this.config.status.search) {
        this.$set(this.config.status, 'searching', true)
        this.axios.get(this.$url.zip + this.form.zip).then(res => {
          console.log(res)
          if (res.data.code === 200) {
            let data = res.data.data
            this.$set(this.form, 'pref', data.pref)
            this.$set(this.form, 'city', data.city)
            this.$set(this.form, 'number', data.town)
            this.$set(this.config.status, 'searching', false)
            this.$refs.number.focus()
            this.$store.dispatch('notifier/addSMessage', {
              title: '住所が見つかりました',
              message: data.pref + data.city + data.town
            })
          } else {
            this.$store.dispatch('notifier/addAlert', {
              title: '住所検索失敗',
              message: this.$error.zip.search.unmatch
            })
          }
        }).catch(error => {
          console.log(error)
        })
      }
    },
    searchSrc: function () {
      this.$set(this.config.status, 'loading', true)
      this.axios.post(`${this.$url.api}user/about/linked/search/address`, {}, {
        headers: {
          'user-token': this.$localStorage.get('jwt')
        }
      }).then(res => {
        console.log(res)
        if (res.data && res.data.success) {
          this.$set(this.store, 'addresses', res.data.data)
        }
        this.$set(this.config.status, 'loading', false)
      })
    },
    cpAddress: function () {
      this.$nextTick(() => {
        if (this.config.address.src) {
          let idx = this.store.addresses.findIndex(it => { return (it.id && it.id === this.config.address.src) })
          if (idx >= 0) {
            let addr = this.store.addresses[idx]
            this.$set(this, 'form', {
              valid: true,
              zip: addr.zip ? addr.zip : '',
              pref: addr.pref ? addr.pref : '',
              city: addr.city ? addr.city : '',
              number: addr.number ? addr.number : '',
              kana: addr.kana ? addr.kana : ''
            })
          }
          this.$nextTick(() => {
            this.$set(this.config.address, 'src', '')
          })
        }
      })
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    isLoading () {
      return this.config.status.loading
    },
    isSearching () {
      return this.config.status.searching
    },
    getPrefItems () {
      return Object.keys(this.$meta.prefs)
    },
    getSrcAddressItems () {
      return this.store.addresses.map(it => {
        return {
          value: it.id,
          text: [
            it.zip ? ('〒' + it.zip.substr(0, 3) + '-' + it.zip.substr(3) + ' ') : '',
            it.pref ? it.pref : '',
            it.city ? it.city : '',
            it.number ? it.number : ''
          ].join('')
        }
      })
    }
  }
}
</script>
